export const BASE_SAVED_SEARCH_URL = "/sales-api/save-search/v2/searches";
